import http from '../httpService';


export function createAMLForm(payload) {
  return http.post('/controlling-forms', payload);
}
export function editAMLForm(id,payload) {
  return http.put(`/controlling-forms/${id}`,payload)
}
export function getAMLForm(id) {
  return http.get(`/controlling-forms?cycleId.equals=${id}`)
}

export function getControllingOverallRiskAssessmentLevels() {
  return http.get(`/controlling-overall-risk-assessment-levels`)
}